<template>
  <div v-if="tags?.length" class="flex text-[24px]">
    <span class="leading-[33px]">Теги:</span>
    <div class="ml-[36px] flex flex-wrap">
      <NuxtLink
        v-for="tag in tags"
        :key="tag.id"
        class="mb-[6px] mr-[6px] rounded-[8px] bg-collection px-[16px] py-[8px] text-[14px] font-medium leading-[17px] text-white-100 last:mr-0"
        :to="`/tags/${tag.slug}`"
        >{{ tag.title }}</NuxtLink
      >
    </div>
  </div>
</template>

<script setup>
defineProps({
  tags: {
    type: Array,
    required: true,
  },
});
</script>
